<template>
    <div
        class="cz2__steps-options__name"
        :class="[
            `cz2__steps-options__name--sb-type-${spellingBeeType}`,
            {
                'is-kiosk': isKiosk,
                'is-virtualkeyboard': useVirtualKeyboardNameEntry,
            },
        ]"
    >
        <main-navigation />

        <div
            ref="rendererPlaceholder"
            class="cz2__renderer-placeholder"
        />

        <base-input
            ref="nameInput"
            :input-text="name"
            :invalid="invalid"
            :error-text="errorText"
            :small-font="smallFont"
            :read-only="useVirtualKeyboardNameEntry || isKiosk"
            :outlined="isKiosk"
            :maximum-length="maxLength"
            labelled-by="step-header-title"
            @input="updateName"
            class="cz2__steps-options__name-input"
        />

        <div
            v-if="isKiosk || useVirtualKeyboardNameEntry"
            class="cz2__steps-options__name-keyboard"
        >
            <keyboard
                :value="name"
                @input="updateNameKeyboard"
                @quotes="quotes"
                :layouts="[
                    '1234567890{DELETE:backspace}|QWERTYUIOP_|ASDFGHJKL-+|{@#Ñ:goto:1}ZXCVBNM,.@|{:space}',
                    `!@#$%^&*(){DELETE:backspace}|ÁÉÍÓÚÜÑ¡/\\_|:;||<=>[]~-+|{ABC:goto:0}{{}}'\`{″:quotes}¿?,.@|{:space}`,
                ]"
            />
        </div>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__sb-logo__name-m, .cz2__sb-logo__name-d, .cz2__sb-logo__name-k {
            display: none;
        }

        .cz2__steps-options__name {
            pointer-events: auto;

            padding: var(--layout-spacing);
            padding-bottom: var(--steps-options-nav-height);

            height: 100%;
            @include bg(gradientBlue);

            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 24px;

            .cz2__renderer-placeholder {
                width: 100%;
                flex: 1 1 0%;
            }
        }

        .cz2__steps-options__name-input {
            margin-bottom: 36px;

            width: 100%;
            display: flex;
            justify-content: center;

            .cz2__input-box {
                width: 100%;
            }
        }

        @include respond-above(sm) {
            .cz2__steps-options__name-input {
                .cz2__input-box {
                    width: 500px;
                }
            }
        }

        @include respond-above(md) {
            .cz2__steps-options__name {
                padding: 48px var(--layout-spacing) var(--steps-options-nav-height) var(--layout-spacing);
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__steps-options__name {
            gap: 40px;

            .cz2__main-navigation-button {
                margin-top: 110px;
            }

            .cz2__steps-options__name-input {
                margin-bottom: 20px;

                .cz2__input-box {
                    width: 600px;
                }
            }
        }
    }

    #cz2.cz2.cz2__is-sb.cz2__is-name-step {
        .cz2__steps-options__name {
            padding: 50px 50px 80px;

            @include respond-above(sm) {
                padding: 90px 0 130px;
            }

            background-size: 50%;
            background-position: center;
            background-repeat: repeat;

            &.cz2__steps-options__name--sb-type-none {
                background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-G@2x.jpg');
                @include respond-above(sm) {
                    background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-G@2x.jpg');
                }
            }

            &.cz2__steps-options__name--sb-type-G {
                background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-G@2x.jpg');
                @include respond-above(sm) {
                    background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-G@2x.jpg');
                }
            }

            &.cz2__steps-options__name--sb-type-H {
                background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-H@2x.jpg');
                @include respond-above(sm) {
                    background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-H@2x.jpg');
                }
            }

            &.cz2__steps-options__name--sb-type-S {
                background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-S@2x.jpg');
                @include respond-above(sm) {
                    background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-S@2x.jpg');
                }
            }

            &.cz2__steps-options__name--sb-type-R {
                background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-R@2x.jpg');
                @include respond-above(sm) {
                    background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-R@2x.jpg');
                }
            }

            background-size: cover;

            background-image: none;
            background-color: transparent;

            position: absolute;
            border-image-source: url('../assets/images/branded/sb-final/SB-Border 3_M@2x.webp');

            border-width: 40px;
            border-image-width: 40px;
            border-image-slice: 80 fill;
            border-image-repeat: stretch;

            height: calc(100% - var(--steps-options-nav-height-sb));
            width: 100%;

            @include respond-above(lg) {
                border-image-source: url('../assets/images/branded/sb-final/SB-Border 3_D@2x.webp');
                height: 100%;
                width: 100%;
                border-width: 70px;
                border-image-width: 70px;
                border-image-slice: 140 fill;
                border-image-repeat: stretch;
            }
        }

        .cz2__steps-options__navigation--name {
            @include respond-above(lg) {
                bottom: 50px;
            }
        }
        .cz2__input-box {
            @include respond-above(lg) {
                margin-bottom: 64px;
                padding-bottom: 0;
            }
            input {
                border-radius: 0;
                border-color: color(sbDarkGold);
                border-width: 4px;
            }
            &.cz2__input-box--active {
                box-shadow: none;
            }
        }
        .cz2__steps-options__name-input {
            margin-bottom: 0;
        }
        .cz2__sb-logo__name-m {
            display: block;
            height: 80px;
        }
        @include respond-above(lg) {
            .cz2__sb-logo__name-m {
                display: none;
            }
            .cz2__sb-logo__name-d {
                display: block;
                height: 120px;
            }
        }
    }

    #cz2.cz2.cz2__is-sb.cz2__is-name-step.cz2__is-kiosk {
        .cz2__steps-options__name {
            height: calc(100% - var(--steps-options-nav-height-sb));

            padding: 90px 0 130px;
        }

        .cz2__main-navigation-button {
            margin-top: 24px;
        }

        .cz2__input-box {
            margin-bottom: 24px;
        }

        .cz2__steps-options__navigation--name {
            bottom: 0;
        }
    }
</style>

<script>
    import Keyboard from './ui/Keyboard.vue';

    import MainNavigation from './MainNavigation.vue';
    import BaseInput from './ui/BaseInput.vue';

    export default {
        components: {
            MainNavigation,
            Keyboard,
            BaseInput,
        },

        props: {
            validate: {
                type: Number,
                required: true,
            },
        },

        data() {
            const name = this.$store.state.customizer.boxName;

            let useName = '';

            if (name) {
                if (name.controller) {
                    useName = name.text;
                } else {
                    useName = name;
                }
            }

            return {
                invalid: null,
                errorText: '',
                name: useName,
                maxLength: 18,
            };
        },

        computed: {
            currentGroup() {
                return this.$store.state.customizer.currentGroup;
            },

            isSpellingBee() {
                return this.$store.state.isSpellingBee;
            },

            spellingBeeType() {
                return this.$store.state.spellingBeeType ?? 'none';
            },

            boxName() {
                return this.$store.state.customizer.boxName;
            },

            options() {
                return this.$store.state.customizer.options;
            },

            isKiosk() {
                return this.options && this.options.isKiosk;
            },

            useVirtualKeyboardNameEntry() {
                if (this.options && this.options.useVirtualKeyboardNameEntry) {
                    return true;
                }

                return false;
            },

            smallFont() {
                return (this.name || '').length > 8;
            },

            seenGroups() {
                return this.$store.state.customizer.seenGroups;
            },

            viewController() {
                return this.$store.state.customizer.viewController;
            },

            isMobile() {
                return this.$store.state.customizer.isMobile;
            },

            isTwoPack() {
                return this.$store.getters.isTwoPack;
            },
        },

        watch: {
            validate() {
                this.validateName();
            },

            currentGroup() {
                this.updateNavigation();
            },
        },

        mounted() {
            this.updateNavigation();

            this.$store.dispatch('updateBoxName', this.boxName);

            this.setFocusOnInput();

            // Remove looks good from navigation. The name must be validated first.
            this.$store.dispatch('unseeGroup', 'Review');

            this.emitter.$emit('setRendererPlaceholder', {
                owner: 'name',
                placeholder: this.$refs.rendererPlaceholder,
            });

            if (this.isTwoPack) {
                this.getSnapshot();
            }
        },

        beforeDestroy() {
            this.emitter.$emit('setRendererPlaceholder', {
                owner: 'name',
            });
        },

        methods: {
            quotes() {
                this.updateNameKeyboard(`${this.name}"`);
            },

            updateNavigation() {
                let returnTo;

                if (this.seenGroups.includes('Packs')) {
                    returnTo = 'Packs';
                } else if (this.seenGroups.includes('Pets')) {
                    returnTo = 'Pets';
                } else if (this.seenGroups.includes('Accessories3')) {
                    returnTo = 'Accessories3';
                } else if (this.seenGroups.includes('Accessories2')) {
                    returnTo = 'Accessories2';
                } else if (this.seenGroups.includes('Accessories1')) {
                    returnTo = 'Accessories1';
                }

                this.$emit('updateNavigation', {
                    hasBack: true,
                    canGoBack: true,
                    hasNext: true,
                    canGoNext: this.name.length > 0,
                    nextSpecial: 'Review',
                    previousSpecial: returnTo,
                    isValidating: false,
                    invalid: this.invalid,
                });
            },

            updateNameKeyboard(newValue) {
                // updateName will trim the name and remove trailing spaces.
                // You can still enter names with spaces because <input> tracks the internal state.
                //
                // But we need to allow the screen keyboard to enter trailing spaces too.
                // If we use updateName, the user can never enter a space.
                //
                // So, instead, if a newly entered name only differs by trailing spaces,
                // simply update the state but skip validations.
                //
                // Only if the new name ends with a space. The screen keyboard does not have a way to move the cursor.
                if (newValue && newValue.substr(newValue.length - 1) === ' ') {
                    const newWithoutSpaces = newValue.replace(/\s+$/, '');

                    if (newWithoutSpaces === this.name) {
                        this.name = newValue;
                    } else {
                        this.updateName(newValue);
                    }
                } else {
                    this.updateName(newValue);
                }
            },

            updateName(newValue) {
                this.name = newValue.trim();

                this.$store.dispatch('updateBoxName', this.name).then((useName) => {
                    this.name = useName;

                    if (newValue.length > this.maxLength) {
                        this.$nextTick(() => {
                            this.invalid = true;
                            this.errorText = this.$t('BOX_NAME_ERROR');
                        });
                    } else {
                        this.invalid = false;
                        this.errorText = '';

                        // Enable/disable Next button as user types
                        this.$emit('updateNavigation', {
                            canGoNext: this.name.length > 0,
                            isValidating: false,
                            invalid: true,
                        });
                    }
                });
            },

            validateName() {
                this.viewController.reviewText(this.name).then((result) => {
                    if (result.hasProfanity) {
                        this.invalid = true;
                        this.errorText = this.$t('BOX_NAME_ERROR_PROFANITY');
                    } else {
                        this.invalid = false;
                    }

                    this.updateNavigation();
                }).catch(() => {
                    this.invalid = true;
                    this.errorText = this.$t('BOX_NAME_ERROR_PROFANITY');

                    this.updateNavigation();
                });
            },

            setFocusOnInput() {
                if (!this.isMobile) {
                    const inputElement = this.$refs.nameInput.$el.children[0].querySelector('input');

                    inputElement.focus();
                }
            },

            async getSnapshot() {
                const popSnapshot = await this.$store.dispatch('snapshot', 'SnapshotNarrow');

                this.$store.dispatch('setPreviewImageByController', popSnapshot);
            },
        },
    };
</script>
